import * as z from "zod/v4";

export const onboardingV2AnalyticsProductIdSchema = z.enum([
  "returns",
  "order-editing",
]);

export const onboardingV2HideArchivedInputSchema = z.object({
  hideArchived: z.boolean().default(true),
});

export const onboardingV2AnalyticsProductInputSchema =
  onboardingV2HideArchivedInputSchema.extend({
    productId: onboardingV2AnalyticsProductIdSchema.optional(),
  });

export const onboardingV2OverviewProductScopeSchema = z.enum([
  "all",
  "returns",
  "order-editing",
]);

export const onboardingV2ReturnsRevenueModeSchema = z.enum([
  "weighted",
  "fully-onboarded",
]);

export type OnboardingV2AnalyticsProductId = z.infer<
  typeof onboardingV2AnalyticsProductIdSchema
>;
export type OnboardingV2OverviewProductScope = z.infer<
  typeof onboardingV2OverviewProductScopeSchema
>;
export type OnboardingV2ReturnsRevenueMode = z.infer<
  typeof onboardingV2ReturnsRevenueModeSchema
>;
